export default __webpack_public_path__ + "static/media/angers9.e54c552a.jpg";